/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Delete_ActionInputs */



/**
* | output |
* | --- |
* | "Delete key" |
*
* @param {Profile_Security_User_Api_Key_Delete_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_delete_action = /** @type {((inputs?: Profile_Security_User_Api_Key_Delete_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Delete_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schlüssel löschen")
	return /** @type {LocalizedString} */ ("Delete key")
});